export const API_RESPONSE_STATUSES = {
    ERROR: 'error',
    SUCCESS: 'success',
};

export const API_ERROR_STATUS_CODE_MESSAGES = {
    302: 'EXCEED_CREDIT_RECHARGE_LIMIT_MSG',
};

export const StatusCodes = {
    OK: 200,

    NO_NEED_TO_PERFORM_ACTION: 201,
    ALREADY_REPORTED: 208,

    ALREADY_EXISTS: 210,
    CAMPAIGN_ALREADY_EXISTS: 211,

    UNABLE_TO_PERFORM_ACTION: 300,
    NOT_ENOUGH_CREDITS: 301,
    EXCEED_CREDIT_RECHARGE_LIMIT: 302,
    CREATE_CAMPAIGN_RESULT_NO_CONTACT_DATA: 303,
    CREDIT_USAGE_LIMITED: 305,

    NOT_FOUND: 400,
    WALLET_NOT_FOUND: 401,
    WORKFLOW_NOT_FOUND: 402,
    POSITION_NOT_FOUND: 403,

    ERROR: 500,
    DB_ERROR: 510,
    DB_INSERT_ERROR: 511,
    VALIDATION_ERROR: 520,

    EMPTY_DB_FILTER: 611,

    POSITION_APPROVAL_LINK_INVALID: 710,
    POSITION_APPROVAL_LINK_SENT_EMAIL_FAILED: 711,

    ALL_EMAILS_ARE_DUPLICATED: 720,
    PART_OF_EMAILS_ARE_DUPLICATED: 721,

    CAMPAIGN_SENDER_IS_NOT_ALLOWED: 810,
    DELETING_CAMPAIGN_ASSOCIATED_EMPLOYER_REP_NOT_ALLOWED: 811,
};

export const SendgridStatusCodes = {
    ACCEPTED: 202,
};
